// extracted by mini-css-extract-plugin
module.exports =  {"rejectButton":"reject_handshake-module_rejectButton_c4b8c"};